import { createSlice } from '@reduxjs/toolkit'
import {getSuppliers, getSuppliersPag} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  suppliers: [], 
  suppliersPag: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  }, 
  loading: "idle",
  loadingPag: "idle",
  error: null }

const suppliersSlice = createSlice({
  name: 'suppliers',
  initialState,
  reducers: {
    clearSuppliersError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getSuppliers.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getSuppliers.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.suppliers = action.payload
    },
    [getSuppliers.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [getSuppliersPag.pending]: (state) => {
        state.loading = "loadingPag"; 
        state.error = null
    },
    [getSuppliersPag.fulfilled]: (state, action) => {
    state.loadingPag = "succeeded";
    state.suppliersPag.elements = action.payload.elements
    state.suppliersPag.pageIndex = action.payload.pageIndex;
    state.suppliersPag.pageSize = action.payload.pageSize;
    state.suppliersPag.totalRecords = action.payload.totalRecords;
    state.suppliersPag.totalPages = action.payload.totalPages;
    state.suppliersPag.hasPreviousPage = action.payload.hasPreviousPage;
    state.suppliersPag.hasNextPage = action.payload.hasNextPage
      
    },
    [getSuppliersPag.rejected]: (state, action) => {
        state.loadingPag = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearSuppliersError} = suppliersSlice.actions;
export default suppliersSlice.reducer
